import router from "@/router/index";
import offcanvas from "bootstrap/js/dist/offcanvas";

const loadPage = {
  mounted(el, binding) {
    let route = binding.value;
    el.addEventListener("click", (e) => {
      if (!route || el.dataset.doLoad == "false") return;
      let delay = el.classList.contains("ripple") || el.classList.contains("ripple-parent") ? 600 : 0;
      setTimeout(() => {
        router.push(route);
        offcanvas.getInstance(document.querySelector(`#offcanvasSearch`))?.hide();
        offcanvas.getInstance(document.querySelector(`#offcanvasNavbar`))?.hide();
        document.querySelector(".modal-backdrop")?.remove();
        document.body.click();
      }, delay);
    });
  },
};

export default loadPage;
